import React, {useEffect,useState} from 'react';
import "../styles.css"
import {API} from "../backend";
import Base from "../core/Base";
import Card from './Card';
import { getProducts } from './helper/coreapicalls';



export default function Home() {

  const [products, setProducts] = useState([])
   const [error, setError] = useState(false)

   const loadAllProduct = () =>{
     getProducts().then(data =>{
       if (data.error) {
         setError(data.error);
       }else{
         setProducts(data);
       }
     });
   };
   useEffect(() => {
     loadAllProduct()
   }, [])

  return (
        <Base title="I WRITE CODE" description="Welcome to the T-shirt Store">
           <div className="row text-center" >
           <h1 className="text-white">All of T-shirts</h1>
           <div className="row">
           {products.map((product, index)=>{
                  return (
                    <div key={index} className="col-3 mb-4">
                    <Card product = {product}/>
                    </div>
                  );
           })} 
           </div>
           </div>
            </Base>
    );
}
